import { z } from "zod";

export const deliveryTypeSchema = z.object({
  id: z.string().max(50),
  name: z.string().max(50),
  carrierId: z.string().max(50),
  carrierName: z.string().readonly().optional(),
  carrierSuiteId: z.string().max(50).readonly(),
  bookingCancelable: z.boolean().readonly(),
  bookingUpdateable: z.boolean().readonly(),
  returnDocuments: z.boolean(),
  dom: z.object({
    value: z.string().max(50),
    serviceCodes: z.array(z.string())
  }).optional(),
  eu: z.object({
    value: z.string().max(50),
    serviceCodes: z.array(z.string())
  }).optional(),
  ex: z.object({
    value: z.string().max(50),
    serviceCodes: z.array(z.string())
  }).optional(),
});

export type DeliveryTypeType = z.infer<typeof deliveryTypeSchema>;